import styled from "styled-components";
import {lineBetweenSlicesColor} from "../../wheel-color-helper";

export const LineBetweenSlicesDefaultBox = styled.div`
    width: 0.5px;
    height: 50%;
    background-color: ${lineBetweenSlicesColor};
`;
